export default __webpack_public_path__ + "static/media/gmail-logo.c49efdc2.svg";